import { render, staticRenderFns } from "./ModalCreateForm.vue?vue&type=template&id=387405a0"
import script from "./ModalCreateForm.vue?vue&type=script&lang=js"
export * from "./ModalCreateForm.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateForm.vue?vue&type=style&index=0&id=387405a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports